
import SendSquare from "../../../assets/outline/SendSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SendSquareIcon({ className, dataTestid = "SendSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SendSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
